import React, { useEffect } from 'react';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { useArchiveIssueModalStates } from './controllers/selectors.tsx';
import { archiveModalEntryPoint } from './entrypoint.tsx';

const runtimeProps = {};
const entryPointParams = {};
const AsyncArchiveIssueModal = (): React.JSX.Element => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		archiveModalEntryPoint,
		entryPointParams,
	);
	const { isArchiveIssueModalOpen } = useArchiveIssueModalStates();

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		if (isArchiveIssueModalOpen) {
			entryPointActions.load();
			return () => {
				entryPointActions.unload();
			};
		}
	}, [entryPointActions, isArchiveIssueModalOpen]);

	return (
		<JiraEntryPointContainer
			id="jira-issue-archival-modal"
			packageName="jiraIssueArchiveModal"
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={runtimeProps}
		/>
	);
};

export default AsyncArchiveIssueModal;
